import React from 'react';
import MedalCLogic from './MedalCriteriaLogic';
import {Layout, Tabs, Typography, Card} from 'antd';
import appColors from '../../style/theme';
const {Content} = Layout;
const {Text} = Typography;
const items_ = [
  {label: <Card
    style={{
      width: 300,
      background: appColors['ColorA'],
      margin: '-8px -16px -10px -16px',
    }}
    cover={
      <img
        alt="example"
        src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
      />
    }
  >
    <Text>MedalC</Text>
  </Card>, key: 'tpage', children: <MedalCLogic/>},
];

const MedalCPage = () => {
  return (
    <Layout>
      <Content style={{padding: '24px', background: appColors['ColorBack']}}>
        <Tabs
          centered='true'
          defaultActiveKey="1"
          type="card"
          items={items_}
        />
      </Content>
    </Layout>
  );
};

export default MedalCPage;
